module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-woman-tee/1-2062d022b3fb8c17cc6feba10236865f.jpg";